import { defineComponent as _defineComponent } from 'vue'
import ConfirmationDialog from "@/components/ConfirmationDialog.vue";
import { ClearMasterUserBidsDocument } from "owfsa-graphql";
import { useCurrSchedDataIdsStore } from "@/stores/currSchedDataIds.store";
import { useMutation } from "@urql/vue";
import { ref } from "vue";
import { toast } from "vue-sonner";


export default /*@__PURE__*/_defineComponent({
  __name: 'ClearBids',
  setup(__props, { expose: __expose }) {
  __expose();

const clearMasterUserBidsMutation = useMutation(ClearMasterUserBidsDocument);
const currSchedDataIdsStore = useCurrSchedDataIdsStore();
const showClearBidsDialog = ref(false);

async function clearBids() {
  // TODO known issue that this won't refetch the bids after clearing them, needs refresh
  const result = await clearMasterUserBidsMutation.executeMutation({
    teamId: currSchedDataIdsStore.currTeamId,
    schedPeriodId: currSchedDataIdsStore.currSchedPeriodId,
  });

  if (!result.error && !!result.data) {
    toast.success("Bids have been cleared successfully");
    showClearBidsDialog.value = false;
  } else {
    const errorCode = result.error?.graphQLErrors?.[0].extensions.code;
    if (errorCode === "LIVE_SCHEDULE_PUBLISHED") {
      toast.error("A live schedule already exists. Please unpublish it before clearing bids.");
    } 
    toast.error("Error has occurred while clearing bids");
  }
}

const __returned__ = { clearMasterUserBidsMutation, currSchedDataIdsStore, showClearBidsDialog, clearBids, ConfirmationDialog }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})